import { a699 } from "Components/Api/RootApiPath";

export const fetchAllStoneAttribute = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a699, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stone attribute list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch stone attribute list, try again later"}`);
  }
};